import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataServiceService } from "../data-service.service";
import { User } from "../model/login";

@Component({
  selector: "app-edit-admin",
  templateUrl: "./edit-admin.component.html",
  styleUrls: ["./edit-admin.component.scss"],
})
export class EditAdminComponent implements OnInit {
  isUserDataValid: boolean = false;
  userId: string = "";
  newRemarks: string = "";
  newStatus: string = "";
  userStatusList: string[] = ["Inforce", "Suspended"];
  newPassword: string = "";
  confirmPassword: string = "";
  userData: User;
  isLoading: boolean = true;
  constructor(
    private modalService: NgbModal,
    private dataService: DataServiceService,
    private route: ActivatedRoute
  ) {
    this.userId = this.route.snapshot.params.userId
      ? this.route.snapshot.params.userId
      : "";
  }

  ngOnInit(): void {
    this.getUserData().then(() => {
      this.isLoading = false;
      if (this.isUserDataValidInfo()) {
        this.newStatus = this.userData.status;
        this.isUserDataValid = true;
      }
    });
  }

  resetPassword(passwordModalContent) {
    this.modalService.open(passwordModalContent, { size: "sm" });
  }

  updateNewPassword() {
    this.dataService
      .updateUserPassword(this.userId, {
        password: this.newPassword,
      })
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }

  updateUserStatus() {
    this.dataService
      .updateUserStatus(this.userId, {
        status: this.newStatus,
        statusRemarks: this.newRemarks,
      })
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
        this.getUserData();
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }

  selectStatus(status) {
    this.newStatus = status;
  }

  changeUserStatus(statusModalContent) {
    this.modalService.open(statusModalContent, { size: "md" });
  }

  invalidPassword() {
    if (!this.validatePassword(this.newPassword.trim())) return true;
    else return false;
  }

  validatePassword = (password) => {
    return String(password).match(
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/gm
    );
  };

  invalidMatchPassword() {
    if (this.newPassword != this.confirmPassword) return true;
    else return false;
  }

  invalidUname() {
    if (this.userData.userName.trim() == "") return true;
    else return false;
  }

  invalidPNum() {
    if (!this.validatePhone(this.userData.phoneNumber)) return true;
    if (
      (this.userData.phoneNumber + "").trim() == "" ||
      this.userData.phoneNumber.length <= 6
    ) {
      return true;
    } else return false;
  }

  validatePhone = (phone) => {
    return String(phone)
      .toLowerCase()
      .match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/);
  };

  invalidForm() {
    return this.invalidUname() || this.invalidPNum();
  }

  async getUserData() {
    this.userData = await this.dataService.getUserById(this.userId);
    this.userData = this.userData[0];
  }

  isUserDataValidInfo() {
    return (
      this.userData &&
      this.userData.userId &&
      this.userData != null &&
      this.userData != undefined
    );
  }

  invalidStatusUpdateForm() {
    if (
      this.userData.status == this.newStatus &&
      this.userData.statusRemarks == this.newRemarks
    )
      return true;
    else return false;
  }

  openSuccessPopup(smallModalContent) {
    this.modalService.open(smallModalContent, { size: "sm" });
  }

  openFailPopup(smallModalContent2) {
    this.modalService.open(smallModalContent2, { size: "sm" });
  }

  updateUser() {
    this.dataService
      .updateUser(this.userId, {
        userName: this.userData.userName,
        phoneNumber: this.userData.phoneNumber,
        startDate: this.userData.startDate,
        endDate: this.userData.endDate,
      })
      .then(() => {
        const but = document.getElementById("successBtn") as HTMLButtonElement;
        but.click();
        this.getUserData();
      })
      .catch(() => {
        const but = document.getElementById("failBtn") as HTMLButtonElement;
        but.click();
      });
  }
}
